module.exports = __webpack_public_path__ + "assets/ic-coinidol.23c67c0f.svg";